import React, { useRef } from 'react';

const FileUpload = (props) => {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        onFileChange,
    } = props;

    const fileRef = useRef();

    return (
        <div className={`form-group ${comp.isRequired ? "required" : ""} ${comp?.cssclass || ""}`} style={{ marginBottom: "16px" }}>
            {comp.label && (
                <label className="form-control-label" htmlFor={controleId} style={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.7px",
                    marginBottom: "6px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                }}>
                    <i className="fa fa-file-text-o" style={{ color: "#94a3b8", fontSize: "11px" }} />
                    {comp.label}
                </label>
            )}

            <input
                id={controleId}
                name={controleId}
                type="file"
                ref={fileRef}
                style={{ display: 'none' }}
                onChange={onFileChange}
                disabled={isDisabled}
            />

            <div className="wf-input-wrap" style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <div style={{ position: "relative", flex: 1 }}>
                    <i className="fa fa-cloud-upload wf-input-icon" aria-hidden="true" />
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Choose a file..."
                        value={data[controleId] || ""}
                        readOnly
                        onClick={() => !isDisabled && fileRef.current.click()}
                        style={{ cursor: isDisabled ? "not-allowed" : "pointer", paddingLeft: "36px" }}
                        disabled={isDisabled}
                    />
                </div>

                <button
                    type="button"
                    onClick={() => !isDisabled && fileRef.current.click()}
                    disabled={isDisabled}
                    style={{
                        height: "38px",
                        fontSize: "13px",
                        padding: "0 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        background: isDisabled ? "#cbd5e1" : "#1e293b",
                        color: isDisabled ? "#334155" : "#ffffff",
                        border: "none",
                        borderRadius: "8px",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease",
                        fontWeight: 600
                    }}
                >
                    <i className="fa fa-upload" /> Browse
                </button>
            </div>

            {errors[controleId] && (
                <div className="alert alert-danger" style={{ marginTop: 6, padding: "5px 10px", fontSize: "11.5px", borderRadius: "7px" }}>
                    {errors[controleId]}
                </div>
            )}
        </div>
    );
}

export default FileUpload;